var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPagingTypeLoadMore)?_c('div',{staticClass:"ta-load-more-wrapper mt-3 text-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updatePagination}},[_vm._v(" "+_vm._s(_vm.$t('Load More'))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }